<template>
  <v-app id="inspire" class="theme--default">
    <transition name="slide-x-transition" mode="out-in">
      <router-view></router-view>
    </transition>
  </v-app>
</template>

<script>
import { loadLanguageAsync } from '@/plugins/i18n';

export default {
  metaInfo: {
    meta: [{ vmid: 'charset', charset: 'utf-8' }],
  },
  mounted() {
    loadLanguageAsync();
  },
};
</script>

<style lang="scss"></style>
